import { render } from "./OldTabContentView.vue?vue&type=template&id=638c6794&scoped=true"
import script from "./OldTabContentView.vue?vue&type=script&lang=js"
export * from "./OldTabContentView.vue?vue&type=script&lang=js"

import "./OldTabContentView.vue?vue&type=style&index=0&id=638c6794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638c6794"]])

export default __exports__